/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { RecordEntry, RecordFolderAssociationPaging, RecordFolderEntry } from '../model';
import { BaseApi } from './base.api';
import { buildCollectionParam } from '../../../alfrescoApiClient';
import { throwIfNotDefined } from '../../../assert';
export class RecordFoldersApi extends BaseApi {
    createRecordFolderChild(recordFolderId, recordBodyCreate, opts) {
        throwIfNotDefined(recordFolderId, 'recordFolderId');
        throwIfNotDefined(recordBodyCreate, 'recordBodyCreate');
        const pathParams = {
            recordFolderId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/record-folders/{recordFolderId}/records',
            pathParams,
            queryParams,
            bodyParam: recordBodyCreate,
            returnType: RecordEntry
        });
    }
    deleteRecordFolder(recordFolderId) {
        throwIfNotDefined(recordFolderId, 'recordFolderId');
        const pathParams = {
            recordFolderId
        };
        return this.delete({
            path: '/record-folders/{recordFolderId}',
            pathParams
        });
    }
    getRecordFolder(recordFolderId, opts) {
        throwIfNotDefined(recordFolderId, 'recordFolderId');
        const pathParams = {
            recordFolderId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/record-folders/{recordFolderId}',
            pathParams,
            queryParams,
            returnType: RecordFolderEntry
        });
    }
    listRecordFolderChildren(recordFolderId, opts) {
        throwIfNotDefined(recordFolderId, 'recordFolderId');
        const pathParams = {
            recordFolderId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            where: opts === null || opts === void 0 ? void 0 : opts.where,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            includeSource: opts === null || opts === void 0 ? void 0 : opts.includeSource,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/record-folders/{recordFolderId}/records',
            pathParams,
            queryParams,
            returnType: RecordFolderAssociationPaging
        });
    }
    updateRecordFolder(recordFolderId, recordFolderBodyUpdate, opts) {
        throwIfNotDefined(recordFolderId, 'recordFolderId');
        throwIfNotDefined(recordFolderBodyUpdate, 'recordFolderBodyUpdate');
        const pathParams = {
            recordFolderId
        };
        const queryParams = {
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv'),
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.put({
            path: '/record-folders/{recordFolderId}',
            pathParams,
            queryParams,
            bodyParam: recordFolderBodyUpdate,
            returnType: RecordFolderEntry
        });
    }
}
